import React, { useEffect, useRef, useState } from 'react'
 
import { Link } from "react-router-dom";

import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import CompActive, { CardSkeleton } from './CompActive.jsx';
import Button from './Button';


const fotourl = import.meta.env.VITE_FOTO || ''

const tamanhotela = window.innerWidth;
import { data_live } from '../api/datalive'

function Slider() {

    const barref = useRef();

    const [trailerList, setTrailerList] = useState([])

    const [isloading, setIsLoading] = useState(true);
    const [activeIndex, setActiveIndex] = useState(0);

    useEffect(
        () => {
          _carregatela()
        }, [])


      async function _carregatela() {


        const rlistatrailer = await data_live.Trailer();

        if (rlistatrailer) {
            setTrailerList(rlistatrailer)
        }
        





        setIsLoading(false)

      }





    const handleScroll = () => {
        const element = barref.current;
        if (element) {
            const index = Math.round(element.scrollLeft / element.offsetWidth);
            setActiveIndex(index);
        }
    };

    const scroll = (scrollOffset) => {
        barref.current.scrollLeft += scrollOffset;
    };

    const btesquerda = () => {
        scroll(-(tamanhotela));
    }
    const btdireita = () => {
        scroll(tamanhotela);
    }


    return (
        <section 
            className="relative w-full"
            aria-label="Carrossel de Conteúdo em Destaque"
        >
            {isloading ? (
                <div className="px-4 md:px-8 lg:px-12">
                    <CardSkeleton className="w-full h-[60vh] rounded-2xl" />
                </div>
            ) : (
                <div className="relative">
                    {/* Navigation Buttons */}
                    <button
                        className="hidden md:flex items-center justify-center absolute left-6 top-1/2 -translate-y-1/2 z-20 w-14 h-14 bg-black/20 backdrop-blur-md text-white rounded-full transition-all duration-300 hover:bg-black/40 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-background"
                        onClick={btesquerda}
                        aria-label="Slide Anterior"
                    >
                        <MdChevronLeft size={40} />
                    </button>
                    <button
                        className="hidden md:flex items-center justify-center absolute right-6 top-1/2 -translate-y-1/2 z-20 w-14 h-14 bg-black/20 backdrop-blur-md text-white rounded-full transition-all duration-300 hover:bg-black/40 hover:scale-105 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-background"
                        onClick={btdireita}
                        aria-label="Próximo Slide"
                    >
                        <MdChevronRight size={40} />
                    </button>

                    {/* Slider Container */}
                    <div 
                        className="flex overflow-x-auto w-full snap-x snap-mandatory scrollbar-hide scroll-smooth"
                        ref={barref}
                        onScroll={handleScroll}
                        role="region"
                        aria-label="Galeria de conteúdo em destaque"
                    >
                        {trailerList.map((item, index) => (
                            <div 
                                key={index} 
                                className="flex-shrink-0 w-full snap-center relative h-[60vh]"
                            >
                                <img 
                                    src={`${fotourl}/${item.fototv}.jpg`} 
                                    alt={`Cena de ${item.username}`}
                                    className="w-full h-full object-cover"
                                    loading="lazy"
                                />
                                
                                <div className="absolute inset-0 bg-gradient-to-t from-background via-background/70 to-transparent" />
                                
                                <div className="absolute bottom-0 left-0 p-8 md:p-12 lg:p-16 max-w-2xl text-white">
                                    <h2 className="text-4xl md:text-6xl font-display font-bold text-text drop-shadow-lg animate-fade-in-up [animation-delay:0.2s]">
                                        {item.username}
                                    </h2>
                                    <p className="mt-4 text-lg text-text-subtle max-w-prose drop-shadow-md animate-fade-in-up [animation-delay:0.4s]">
                                       Viva a experiência completa. Clique para assistir agora.
                                    </p>
                                    <div className="mt-6 animate-fade-in-up [animation-delay:0.6s]">
                                        <Link to={`/Canal/${item.linktoken}`}>
                                            <Button variant="primary" size="lg">
                                                Assista Agora
                                            </Button>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Pagination Dots */}
                    {trailerList.length > 1 && (
                        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex justify-center space-x-3 z-20">
                            {trailerList.map((_, index) => (
                                <button
                                    key={index}
                                    className={`w-3 h-3 rounded-full transition-all duration-300 ${activeIndex === index ? 'bg-primary scale-110' : 'bg-surface/50 hover:bg-surface'}`}
                                    aria-label={`Ir para o slide ${index + 1}`}
                                    onClick={() => {
                                        const element = barref.current;
                                        element.scrollLeft = index * element.offsetWidth;
                                    }}
                                />
                            ))}
                        </div>
                    )}
                </div>
            )}
        </section>
    )
}

export default Slider